/* Levora Stores — Custom Product Gallery Lightbox
   Add this file to: Online Store > Themes > Edit code > Assets > Add a new asset
   Then include both files in theme.liquid (see instructions in chat) */

(function () {
  function initLevoraGallery() {
    // Dawn's product gallery wrapper — a few common selectors covered for safety
    var galleries = document.querySelectorAll(
      '.product-media-gallery, .product__media-list, [id^="MediaGallery-"], [id^="Slider-Gallery"]'
    );
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      var seen = [];
      var images = Array.from(gallery.querySelectorAll('img')).filter(function (img) {
        if (seen.indexOf(img.src) !== -1) return false;
        seen.push(img.src);
        return true;
      });
      if (!images.length) return;

      images.forEach(function (img, index) {
        img.style.cursor = 'zoom-in';
        // capture: true so this fires BEFORE Dawn's own modal-open listener on the
        // parent button/link, and stopPropagation blocks Dawn's native modal from opening too
        img.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            openLightbox(images, index);
          },
          true
        );
      });
    });
  }

  function highRes(src) {
    // Shopify CDN images have a _WIDTHx suffix before the extension — bump it up for the lightbox
    return src.replace(/_(\d+)x(\.[a-zA-Z]+)(\?|$)/, '_1600x$2$3');
  }

  function getDist(t1, t2) {
    var dx = t2.clientX - t1.clientX;
    var dy = t2.clientY - t1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function openLightbox(images, startIndex) {
    var existing = document.getElementById('levora-lightbox');
    if (existing) existing.remove();

    var isTouch = 'ontouchstart' in window;

    var box = document.createElement('div');
    box.id = 'levora-lightbox';
    box.innerHTML =
      '<button class="lightbox-close" aria-label="Close">&times;</button>' +
      '<div class="lightbox-main">' +
      '<button class="lightbox-arrow prev" aria-label="Previous">&#10094;</button>' +
      '<img src="" alt="">' +
      '<button class="lightbox-arrow next" aria-label="Next">&#10095;</button>' +
      '<div class="zoom-hint">' + (isTouch ? 'Pinch to zoom' : 'Scroll or click to zoom') + '</div>' +
      '</div>' +
      '<div class="lightbox-thumbs"></div>';
    document.body.appendChild(box);

    var mainImg = box.querySelector('.lightbox-main img');
    var mainArea = box.querySelector('.lightbox-main');
    var thumbWrap = box.querySelector('.lightbox-thumbs');
    var hint = box.querySelector('.zoom-hint');
    var current = startIndex;

    // ---- zoom/pan state ----
    var scale = 1;
    var translateX = 0;
    var translateY = 0;
    var MAX_SCALE = 4;

    function applyTransform() {
      mainImg.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')';
    }

    function zoomAt(clientX, clientY, newScale) {
      var rect = mainImg.getBoundingClientRect();
      var offsetX = (clientX - rect.left) / rect.width;
      var offsetY = (clientY - rect.top) / rect.height;
      scale = Math.min(MAX_SCALE, Math.max(1, newScale));
      if (scale <= 1.02) {
        resetZoom();
        return;
      }
      translateX = (0.5 - offsetX) * rect.width * (scale - 1) / scale;
      translateY = (0.5 - offsetY) * rect.height * (scale - 1) / scale;
      mainImg.classList.add('zoomed');
      applyTransform();
    }

    function resetZoom() {
      scale = 1;
      translateX = 0;
      translateY = 0;
      mainImg.classList.remove('zoomed');
      applyTransform();
    }

    // smooth = true for taps/clicks/scroll (soft eased animation)
    // smooth = false during active pinch/drag (instant, follows the finger 1:1)
    function setTransition(smooth) {
      mainImg.style.transition = smooth ? 'transform 0.35s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
    }

    function toggleZoomAt(clientX, clientY) {
      if (scale === 1) {
        zoomAt(clientX, clientY, 2.5);
      } else {
        resetZoom();
      }
    }

    images.forEach(function (img, i) {
      var t = document.createElement('img');
      t.src = img.src;
      t.addEventListener('click', function () {
        show(i);
      });
      thumbWrap.appendChild(t);
    });

    function show(index) {
      current = (index + images.length) % images.length;
      resetZoom();
      mainImg.src = highRes(images[current].src);
      Array.from(thumbWrap.children).forEach(function (t, i) {
        t.classList.toggle('active', i === current);
      });
      var activeThumb = thumbWrap.children[current];
      if (activeThumb) activeThumb.scrollIntoView({ inline: 'center', block: 'nearest' });
    }

    function close() {
      document.removeEventListener('keydown', keyHandler);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      box.remove();
      document.body.style.overflow = '';
    }

    function keyHandler(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    }

    box.querySelector('.lightbox-close').addEventListener('click', close);
    box.addEventListener('click', function (e) {
      if (e.target === box) close();
    });
    box.querySelector('.prev').addEventListener('click', function () {
      show(current - 1);
    });
    box.querySelector('.next').addEventListener('click', function () {
      show(current + 1);
    });
    document.addEventListener('keydown', keyHandler);

    // ---- click to zoom (desktop + fallback tap) ----
    mainImg.addEventListener('click', function (e) {
      e.stopPropagation();
      setTransition(true);
      toggleZoomAt(e.clientX, e.clientY);
    });

    // ---- scroll wheel zoom (desktop) ----
    mainArea.addEventListener(
      'wheel',
      function (e) {
        e.preventDefault();
        setTransition(true);
        var delta = e.deltaY < 0 ? 0.35 : -0.35;
        zoomAt(e.clientX, e.clientY, scale + delta);
      },
      { passive: false }
    );

    // ---- drag to pan when zoomed (desktop) ----
    var isDragging = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var startTranslateX = 0;
    var startTranslateY = 0;

    mainImg.addEventListener('mousedown', function (e) {
      if (scale === 1) return;
      isDragging = true;
      setTransition(false);
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      startTranslateX = translateX;
      startTranslateY = translateY;
      e.preventDefault();
    });

    function onMouseMove(e) {
      if (!isDragging) return;
      translateX = startTranslateX + (e.clientX - dragStartX);
      translateY = startTranslateY + (e.clientY - dragStartY);
      applyTransform();
    }
    function onMouseUp() {
      if (isDragging) setTransition(true);
      isDragging = false;
    }
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);

    // ---- touch: pinch to zoom, pan when zoomed, swipe to change image when not zoomed ----
    var touchMode = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    var panStartTranslateX = 0;
    var panStartTranslateY = 0;
    var lastTapTime = 0;

    box.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length === 2) {
          touchMode = 'pinch';
          setTransition(false);
          pinchStartDist = getDist(e.touches[0], e.touches[1]);
          pinchStartScale = scale;
        } else if (e.touches.length === 1) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;

          var now = Date.now();
          if (now - lastTapTime < 300) {
            touchMode = null;
            lastTapTime = 0;
            setTransition(true);
            toggleZoomAt(e.touches[0].clientX, e.touches[0].clientY);
            return;
          }
          lastTapTime = now;

          if (scale > 1) {
            touchMode = 'pan';
            setTransition(false);
            panStartTranslateX = translateX;
            panStartTranslateY = translateY;
          } else {
            touchMode = 'swipe';
          }
        }
      },
      { passive: true }
    );

    box.addEventListener(
      'touchmove',
      function (e) {
        if (touchMode === 'pinch' && e.touches.length === 2) {
          e.preventDefault();
          var dist = getDist(e.touches[0], e.touches[1]);
          var newScale = Math.min(MAX_SCALE, Math.max(1, pinchStartScale * (dist / pinchStartDist)));
          scale = newScale;
          if (scale <= 1.02) {
            resetZoom();
          } else {
            mainImg.classList.add('zoomed');
            applyTransform();
          }
        } else if (touchMode === 'pan' && e.touches.length === 1) {
          e.preventDefault();
          translateX = panStartTranslateX + (e.touches[0].clientX - touchStartX);
          translateY = panStartTranslateY + (e.touches[0].clientY - touchStartY);
          applyTransform();
        }
      },
      { passive: false }
    );

    box.addEventListener('touchend', function (e) {
      if (touchMode === 'swipe') {
        var diff = e.changedTouches[0].clientX - touchStartX;
        if (diff > 50) show(current - 1);
        if (diff < -50) show(current + 1);
      }
      if (touchMode === 'pinch' || touchMode === 'pan') {
        setTransition(true);
      }
      touchMode = null;
    });

    document.body.style.overflow = 'hidden';
    box.classList.add('active');
    show(startIndex);

    if (hint) {
      setTimeout(function () {
        hint.classList.add('hide');
      }, 2200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLevoraGallery);
  } else {
    initLevoraGallery();
  }
})();